import { render } from "./DaftarAlbumDocumen.vue?vue&type=template&id=37ac82ee"
import script from "./DaftarAlbumDocumen.vue?vue&type=script&lang=js"
export * from "./DaftarAlbumDocumen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__